<div class="topbar">
	<!-- Desktop Header -->
	<div class="desktop-section">
		<div class="header-left-group">
			<a [routerLink]="['/dashboard']" class="topbar-logo" aria-label="EHE Health Home">
				<img src="assets/images/ehe_pulse_logo.svg" alt="EHE Health" class="topbar-logo--white" />
				<img src="assets/images/ehe_pulse_logo_black.svg" alt="EHE Health" class="topbar-logo--black" />
			</a>
			<div class="welcome-text">Welcome, {{ firstName }}</div>
		</div>

		<div class="topbar-actions-pill">
			<div class="phone-number">
				<span
					appEheAnalytics
					[data]="{
						pageUrl: '/scheduling/create/appointment',
						componentName: 'header',
						id: 'navbar-phone-number',
						placement: 'header-menu-phone-number'
					}">
					<a href="tel:8886728172" aria-label="888.672.8172">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path
								d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24 11.36 11.36 0 003.56.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.56 1 1 0 01-.25 1.02l-2.2 2.21z"
								stroke="currentColor"
								stroke-width="2.5"
								stroke-linecap="round"
								stroke-linejoin="round" />
						</svg>
						<span>888.672.8172</span>
					</a>
				</span>
			</div>
			<!-- Book Exam Button -->
			<button *ngIf="!isOnBookingOrPaymentPage" type="button" class="book-exam-btn" (click)="bookExam()">
				<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
					<rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2.5" />
					<line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2.5" />
					<line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2.5" />
					<line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2.5" />
				</svg>
				Book Exam
			</button>
		</div>
	</div>

	<!-- Mobile Header -->
	<div class="mobile-section" *ngIf="profileData">
		<a [routerLink]="['/dashboard']" class="topbar-logo-mobile" aria-label="EHE Health Home">
			<img src="assets/images/ehe_pulse_logo.svg" alt="EHE Health" class="tw-h-8 tw-w-auto" />
		</a>
		<div class="mobile-actions">
			<a href="tel:8886728172" class="mobile-phone-link" aria-label="888.672.8172">
				<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M15.0667 16C13.2148 16 11.3852 15.5963 9.57778 14.7889C7.77037 13.9815 6.12593 12.837 4.64444 11.3556C3.16296 9.87407 2.01852 8.22963 1.21111 6.42222C0.403704 4.61481 0 2.78519 0 0.933333C0 0.666667 0.0888889 0.444444 0.266667 0.266667C0.444444 0.0888889 0.666667 0 0.933333 0H4.53333C4.74074 0 4.92593 0.0703704 5.08889 0.211111C5.25185 0.351852 5.34815 0.518519 5.37778 0.711111L5.95556 3.82222C5.98519 4.05926 5.97778 4.25926 5.93333 4.42222C5.88889 4.58519 5.80741 4.72593 5.68889 4.84444L3.53333 7.02222C3.82963 7.57037 4.18148 8.1 4.58889 8.61111C4.9963 9.12222 5.44444 9.61481 5.93333 10.0889C6.39259 10.5481 6.87407 10.9741 7.37778 11.3667C7.88148 11.7593 8.41481 12.1185 8.97778 12.4444L11.0667 10.3556C11.2 10.2222 11.3741 10.1222 11.5889 10.0556C11.8037 9.98889 12.0148 9.97037 12.2222 10L15.2889 10.6222C15.4963 10.6815 15.6667 10.7889 15.8 10.9444C15.9333 11.1 16 11.2741 16 11.4667V15.0667C16 15.3333 15.9111 15.5556 15.7333 15.7333C15.5556 15.9111 15.3333 16 15.0667 16ZM2.68889 5.33333L4.15556 3.86667L3.77778 1.77778H1.8C1.87407 2.38519 1.97778 2.98519 2.11111 3.57778C2.24444 4.17037 2.43704 4.75556 2.68889 5.33333ZM10.6444 13.2889C11.2222 13.5407 11.8111 13.7407 12.4111 13.8889C13.0111 14.037 13.6148 14.1333 14.2222 14.1778V12.2222L12.1333 11.8L10.6444 13.2889Z"
						fill="white" />
				</svg>
			</a>
			<button *ngIf="!isOnBookingOrPaymentPage" type="button" class="mobile-book-exam-btn" (click)="bookExam()">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
					<rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2" />
					<line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" />
					<line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" />
					<line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2" />
				</svg>
			</button>
		</div>
	</div>
</div>
